"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tripSourceDetailWithSource = void 0;
const first_1 = __importDefault(require("lodash/first"));
const TripSourceDetail_1 = require("../models/TripSourceDetail");
const expect_1 = __importDefault(require("../util/expect"));
const PATH = 'trip-source-details';
async function tripSourceDetailWithSource(source, firestore) {
    const results = await firestore.list(PATH, {
        where: [['source', '==', source]],
    });
    const result = (0, expect_1.default)((0, first_1.default)(results));
    return (0, TripSourceDetail_1.tripSourceDetailDeserialize)(result.value);
}
exports.tripSourceDetailWithSource = tripSourceDetailWithSource;
